var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"enable-footer":false}},[_c('VContainer',{attrs:{"id":"register-page","fill-height":"","fluid":""}},[_c('Dialog',{attrs:{"fullscreen":"","dismissable":false,"is-dialog-open":true,"fill-height":"","card-class":{
        'dark-overlay': true
      }}},[_c('VRow',{attrs:{"fill-height":"","row":"","align-center":"","justify-center":""}},[_c('VCol',{attrs:{"lg":"6","md":"8","cols":"12"}},[_c('RequestInvitation')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }